import { useParams } from 'react-router-dom';
import { PageShell, PageTopRow, ContentCard } from '@/components/ui/page-shell';
import { BackButton } from '@/components/ui/back-button';
import { guideBySlug } from '@/guides';
import { renderGuideMarkdown } from '@/lib/guide-markdown';

/**
 * Reader for a single guide. The markdown carries its own # title, so the
 * top row holds just the back control; the article styles are scoped here
 * because the client has no typography plugin.
 */
export function GuideReader() {
  const { slug } = useParams<{ slug: string }>();
  const guide = slug ? guideBySlug(slug) : undefined;

  return (
    <PageShell>
      <PageTopRow>
        <BackButton href="/dashboard/guides" tooltip="All guides" />
        <h1 className="text-lg font-semibold">{guide ? guide.title : 'Guide'}</h1>
      </PageTopRow>

      <ContentCard>
        {!guide ? (
          <div className="h-full flex flex-col items-center justify-center text-center text-foreground">
            <p>This guide does not exist.</p>
          </div>
        ) : (
          <article
            className="max-w-2xl mx-auto pb-8 leading-relaxed
              [&_h1]:text-2xl [&_h1]:font-semibold [&_h1]:mb-4 [&_h1]:mt-2
              [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:mt-8 [&_h2]:mb-3
              [&_h3]:text-base [&_h3]:font-semibold [&_h3]:mt-6 [&_h3]:mb-2
              [&_p]:mb-4 [&_p]:text-[0.95rem]
              [&_ul]:mb-4 [&_ul]:pl-5 [&_ul]:list-disc [&_ol]:mb-4 [&_ol]:pl-5 [&_ol]:list-decimal
              [&_li]:mb-1.5 [&_li]:text-[0.95rem]
              [&_blockquote]:border-l-2 [&_blockquote]:border-primary/40 [&_blockquote]:pl-4 [&_blockquote]:text-content-strong [&_blockquote]:mb-4
              [&_hr]:my-8 [&_hr]:border-border"
          >
            {renderGuideMarkdown(guide.markdown)}
          </article>
        )}
      </ContentCard>
    </PageShell>
  );
}

export default GuideReader;
